import { createSlice } from "@reduxjs/toolkit";
import { addBanner, editBanner, getBanner, getBannerList } from "../services/banner-services";

const initialState = {
  banners: [],
  banner: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBannerList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getBannerList.fulfilled, (state, action) => {
        state.banners = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getBannerList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getBanner.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getBanner.fulfilled, (state, action) => {
        state.banners = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getBanner.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addBanner.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(addBanner.fulfilled, (state, action) => {
        state.banners = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addBanner.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editBanner.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(editBanner.fulfilled, (state, action) => {
        state.banners = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editBanner.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      
  },
});
export const { resetSuccess, resetState, resetError } = bannerSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default bannerSlice.reducer;
